import type { FC } from 'react'
import { Card, CardProps, SxProps, Theme } from '@mui/material'

const styles: Record<string, SxProps<Theme>> = {
  card: (theme) => ({
    width: '100%',
    height: '100%',
    cursor: 'pointer',
    borderWidth: '1px',
    borderStyle: 'solid',
    borderColor: theme.palette.grey[300],
  }),
  selected: (theme) => ({
    borderColor: theme.palette.grey[700],
  }),
}

export type SelectableCardProps = CardProps & {
  isSelected?: boolean
}

export const SelectableCard: FC<SelectableCardProps> = ({ isSelected = false, sx, ...props }) => (
  <Card
    {...props}
    data-selected={isSelected}
    sx={[styles.card, isSelected ? styles.selected : {}, sx] as SxProps<Theme>}
  />
)
